<template>
  <div class="course-item" @click="$emit('toDetail', row)">
    <div class="img">
      <VanImg
        width="100%"
        height="100%"
        fit="cover"
        :src="row.courseCoverUrl"
      />
    </div>
    <div class="course-info">
      <div class="top">
        <h3 class="title">
          {{ row.courseName }}
        </h3>
      </div>
      <div class="tip">
        <span v-if="row.knowledgeCount"
          >知识点 {{ row.finishKnowledgeCount || 0 }}/{{
            row.knowledgeCount
          }}</span
        >
        <span v-if="row.testPaperCount"
          >试卷 {{ row.finishTestPaperCount || 0 }}/{{
            row.testPaperCount
          }}</span
        >
        <span v-if="row.questionCount">试题数*{{ row.questionCount }}</span>
      </div>
      <!-- <div class="study">
        已学{{
          row.finishKnowledgeCount ? row.finishKnowledgeCount : 0
        }}个知识点
      </div> -->
      <!-- <div class="btn" v-else>开始学习</div> -->
    </div>
    <img class="icon" v-if="row.pastDueFlag == 1" src="./img/gq.png" alt="" />
    <img
      class="icon"
      v-else-if="row.studyFinishFlag == 1"
      src="./img/ywc.png"
      alt=""
    />
  </div>
</template>

<script>
import { Image as VanImg } from "vant";
export default {
  name: "CourseItem",
  props: {
    row: Object
  },
  components: { VanImg }
};
</script>

<style scoped lang="scss">
.course-item {
  display: flex;
  width: 100%;
  height: 94px;
  position: relative;
  .img {
    width: 165px;
    height: 100%;
    margin-right: 18px;
  }
  .icon {
    position: absolute;
    top: 20px;
    right: 10px;
    width: 70px;
    height: 70px;
  }
  .course-info {
    flex: 1;
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;
    .title {
      width: 100%;
      margin: 0;
      font-size: 15px;
      color: #222;
      line-height: 19px;
      overflow: hidden;
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .tip {
      color: #999;
      display: block;
      margin-top: 8px;
      font-size: 12px;
    }
    .study {
      color: #ff4444;
    }
    .btn {
      color: #6b3603;
    }
    span {
      display: inline-block;
      &:not(:last-child):after {
        content: "";
        width: 1px;
        height: 10px;
        background: rgba(153, 153, 153, 1);
        display: inline-block;
        margin: 0 5px;
      }
    }
  }
}
</style>
